import React, { useEffect, useState } from 'react';
import axios from 'axios';
import NewArrivalsCard from '../../Components/NewArrivals/NewArrivalsCard';

const Search = ({ golobalKeyword, searchKeyword, selectedCategoryId, t }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const hasKeyword = golobalKeyword && golobalKeyword.trim();
    const hasCategory = selectedCategoryId && selectedCategoryId !== 'all';

    if (!hasKeyword && !hasCategory) {
      setSearchResults([]);
      return;
    }

    const params = new URLSearchParams();
    if (hasKeyword) {
      params.append('name', golobalKeyword.trim());
    }
    if (hasCategory) {
      params.append('category_id', selectedCategoryId);
    }

    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/search?${params.toString()}`)
      .then((response) => {
        setSearchResults(response.data.products || []);
      })
      .catch((error) => {
        console.error("Search error:", error);
        setSearchResults([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [golobalKeyword, selectedCategoryId]);

  return (
    <div className="container p-4 new-arrivals-container">
      <div className="d-flex align-items-center">
        <h1>{t("Search--")}{searchKeyword}</h1>
      </div>
      <div className="row gy-5">
        {loading ? (
          <h1>Loading....</h1>
        ) : searchResults.length ? (
          searchResults.map((product) => (
            <div className="col-md-3" key={product.id}>
              <NewArrivalsCard
                productObj={product}
                title={product.name}
                price={`৳${product.price}`}
                image={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}/${product.photo}`}
                t={t}
              />
            </div>
          ))
        ) : (
          <h1>No results found.</h1>
        )}
      </div>
    </div>
  );
};

export default Search;